export var NAME = 'digitalOrders';
export var DIGITAL_ORDER_CREATED = "".concat(NAME, "/DIGITAL_ORDER_CREATED");
export var DIGITAL_ORDER_CREATION_REQUESTED = "".concat(NAME, "/DIGITAL_ORDER_CREATION_REQUESTED");
export var DIGITAL_ORDER_SEARCH_COMPLETED = "".concat(NAME, "/DIGITAL_ORDER_SEARCH_COMPLETED");
export var DIGITAL_ORDER_SEARCH_REQUESTED = "".concat(NAME, "/DIGITAL_ORDER_SEARCH_REQUESTED");
export var DIGITAL_ORDER_WORD_COUNT_EXCEEDED = "".concat(NAME, "/DIGITAL_ORDER_WORD_COUNT_EXCEEDED");
export var DIGITAL_ORDERS_UPDATED = "".concat(NAME, "/DIGITAL_ORDERS_UPDATED");
export var DIGITAL_TRANSLATION_ARCHIVED = "".concat(NAME, "/DIGITAL_TRANSLATION_ARCHIVED");
export var DIGITAL_ORDERS_DISPLAY_UPDATED = "".concat(NAME, "/DIGITAL_ORDERS_DISPLAY_UPDATED");
export var DOWNLOAD_URL_REQUESTED = "".concat(NAME, "/DOWNLOAD_URL_REQUESTED");
export var DOWNLOAD_URL_REQUEST_COMPLETE = "".concat(NAME, "/DOWNLOAD_URL_REQUEST_COMPLETE");
export var DOWNLOAD_URL_REQUEST_PROGRESS = "".concat(NAME, "/DOWNLOAD_URL_REQUEST_PROGRESS");
export var TYPE_EDITING = 'editing';
export var TYPE_TRANSLATION = 'translation';
export var NUMBER_OF_SECONDS_BETWEEN_UPDATES = 30;
export var STATUS_PROCESSING = 'processing';
export var STATUS_COMPLETED = 'completed';
export var STATUS_FAILED = 'failed';
export var STATUSES = {
  STATUS_PROCESSING: STATUS_PROCESSING,
  STATUS_COMPLETED: STATUS_COMPLETED,
  STATUS_FAILED: STATUS_FAILED
};
export var TRANSLATIONS_ACCESS_TYPE = {
  USES: 'uses-type',
  NONE: 'none',
  PREVIOUS_UPLOADS: 'previous-uploads-type'
};